<div id="placements" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h1 class="title">Placement Cell</h1>
    <p class="inner-lead mt-3">
      Conduct placement drives and job fairs to provide a platform for students to interact with potential employers.
      This is just like a <strong>'Bridging Dreams with Opportunities'</strong>.
    </p>

    <hr class="divider">

    <h4 class="section-subtitle">Placement Reports</h4>
    <div class="row g-3 mt-2">
      <div class="col-md-4">
        <a href="assets/pdf/academics/Placement-Cell-2023-24.pdf" target="_blank"
          class="pdf-download-btn w-100 text-center">
          <i class="fa fa-file-pdf-o me-2"></i>Placement Cell 2023-24
        </a>
      </div>
      <div class="col-md-4">
        <a href="assets/pdf/academics/Placement-Cell-2022-23.pdf" target="_blank"
          class="pdf-download-btn w-100 text-center">
          <i class="fa fa-file-pdf-o me-2"></i>Placement Cell 2022-23
        </a>
      </div>
      <div class="col-md-4">
        <a href="assets/pdf/academics/Placement-Cell-2021-22.pdf" target="_blank"
          class="pdf-download-btn w-100 text-center">
          <i class="fa fa-file-pdf-o me-2"></i>Placement Cell 2021-22
        </a>
      </div>
    </div>

  </div>
</div>